<div #menuEl class="column-menu" [id]="'column-menu-' + columnKey" role="region"
  [attr.aria-label]="column.label + ' column options'" (click)="$event.stopPropagation()"
  (keydown)="onMenuKeydown($event)">
  <div class="menu-section" *ngIf="column.filterable">
    <div class="menu-label">Filter by condition:</div>
    <select class="menu-select" [(ngModel)]="operator" aria-label="Filter operator">
      <option value="">None</option>
      <option value="contains">Contains</option>
      <option value="notContains">Does not contain</option>
      <option value="equals">Equals</option>
      <option value="notEquals">Not equals</option>
      <option value="startsWith">Starts with</option>
      <option value="endsWith">Ends with</option>
      <option value="isEmpty">Is empty</option>
      <option value="isNotEmpty">Is not empty</option>
      <ng-container *ngIf="column.type === 'number' || column.type === 'currency'">
        <option value="greaterThan">Greater than</option>
        <option value="lessThan">Less than</option>
      </ng-container>
    </select>
    <div class="menu-label">Filter by value:</div>
    <input type="text" class="menu-input" placeholder="Search..."
      [(ngModel)]="filterValue" aria-label="Filter value" />
  </div>
  <div class="menu-footer">
    <button type="button" class="btn-primary" (click)="onApply()" aria-label="Apply filter">OK</button>
    <button type="button" class="btn-secondary" (click)="onCancel()" aria-label="Cancel">Cancel</button>
  </div>
</div>
